import styled, { createGlobalStyle } from "styled-components";
import { useTranslation } from "react-i18next";
import { Table, Drawer } from "@renderbus/ui";
import { InvoiceSearch } from "./invoice-operate";
import { useGetInvoiceRecordTable } from "../hooks/useInitInvoiceRecordTable";
import { useInvoiceStore } from "../store/invoice-store";
import { InvoiceDetail } from "./invoice-detail";
import { useInitRecordInfo } from "../hooks/useInitRecordInfo";
import { Link } from "react-router-dom";
import { useState } from "react";
import SearchBar from "@/components/search-bar";
import { getInvoiceRecordSearchConfig } from "../helper/search-config";

const InvoiceRecordWrapper = styled.div`
  padding: 30px 24px 20px;
`;
const InvoiceSearchRecord = styled(InvoiceSearch)`
  justify-content: space-between;
  button {
    margin-left: 16px;
    &:focus {
      background: transparent;
    }
  }
  a {
    color: var(--main-color);
    font-size: 12px;
  }
  div {
    display: flex;
  }
`;
const PageStyle = createGlobalStyle`
  .ant-table-filter-dropdown .ant-dropdown-menu{
    background: #333336 !important;
  }
`;

export default function InvoiceRecord() {
  const { t } = useTranslation("invoice");
  const columns = useGetInvoiceRecordTable();
  const { openDrawer, setOpenDrawer } = useInvoiceStore();
  const [currentPageNum, setCurrentPageNum] = useState(1);
  const {
    invoiceRecordInfo,
    invoiceRecordForm,
    setCurrentFilter,
    fetchInvoiceRecord,
  } = useInitRecordInfo();

  return (
    <InvoiceRecordWrapper>
      <InvoiceSearchRecord>
        <div>
          <SearchBar
            searchConfig={getInvoiceRecordSearchConfig()}
            searchForm={invoiceRecordForm}
            showButtonIcon
            onSearch={() => fetchInvoiceRecord()}
          />
        </div>
        <Link to={{ pathname: "/invoice/previous" }}>
          {t("invoice_history_entry")}
        </Link>
      </InvoiceSearchRecord>
      <Table
        id="invoice-record-table"
        dataSource={invoiceRecordInfo.items}
        columns={columns}
        showQuickJumper={true}
        total={invoiceRecordInfo.total}
        defaultPageSize={15}
        scroll={{ x: true, y: 396 }}
        paginationCurrent={currentPageNum}
        onPageNumChange={(key: number) => {
          setCurrentPageNum(key);
          fetchInvoiceRecord(key);
        }}
        className="invoice-table"
        onChange={(pagination, filters, sorter, extra) => {
          setCurrentFilter(filters);
        }}
        getPopupContainer={() =>
          document.querySelector("invoice-record-table") as HTMLElement
        }
      />
      <PageStyle />
      <Drawer
        width={600}
        open={openDrawer}
        title={t("invoice_detail_title")}
        onClose={() => setOpenDrawer(false)}
        drawerContent={<InvoiceDetail />}
      />
    </InvoiceRecordWrapper>
  );
}
